import { create } from "zustand";

type BatchEventStore = {
  grantsRefreshAt: number;
  triggerGrantsRefresh: () => void;
};

export const useBatchEventStore = create<BatchEventStore>()((set) => ({
  grantsRefreshAt: 0,
  triggerGrantsRefresh: () => set({ grantsRefreshAt: Date.now() }),
}));
